import apiClient from './client';
import { referralsApiUrl, referralShareApiUrl } from '../utils/runtime';

export async function loadMyReferral() {
  return apiClient.get(referralsApiUrl || '/wp-json/pfandpirat/v1/me/referral');
}

export async function logReferralShare(channel) {
  return apiClient.post(
    referralShareApiUrl || '/wp-json/pfandpirat/v1/me/referral/share',
    { channel }
  );
}
